/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Hero_Image_AltInputs */

const en_fc_home_hero_image_alt = /** @type {(inputs: Fc_Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FilmCraft video editor interface with effect controls, program monitor and a multitrack timeline`)
};

/**
* | output |
* | --- |
* | "FilmCraft video editor interface with effect controls, program monitor and a multitrack timeline" |
*
* @param {Fc_Home_Hero_Image_AltInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_hero_image_alt = /** @type {((inputs?: Fc_Home_Hero_Image_AltInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Hero_Image_AltInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_hero_image_alt(inputs)
});
export { fc_home_hero_image_alt as "fc.home.hero.image_alt" }